import { ApiResponse } from "../types/common";
import {
  ProductDetailsRequest,
  ProductDetailsResponse,
  WarmupResult,
} from "../types/products";

import apiClient, { withLongTimeout } from "./apiClient";

export const getProductDetails = (
  data: ProductDetailsRequest
): Promise<ApiResponse<ProductDetailsResponse>> => {
  return apiClient
    .get(`/Products/${data.productId}`, withLongTimeout({
      params: {
        retailer: data.retailer,
      },
    }))
    .then((response) => response.data);
};

export const warmupProduct = (
  productId: string,
  retailer: string
): Promise<WarmupResult> => {
  return apiClient
    .post(`/Products/warmup`, {
      productId,
      retailer,
    })
    .then((response) => response.data);
};
